// import Calendar from "@/utils/calendar";

const taglist = [
  { value: 1, label: "转正品" },
  { value: 2, label: "退货" },
  { value: 3, label: "新采购单入库" },
  { value: 10, label: "转公司库存" },
  { value: 11, label: "转用户库存" },
];
const warehouselist = ['待处理','已处理']
const servicelist =['未解决','已解决']

export const columns = [
  {
    title: "#",
    dataIndex: "id",
    key: "id",
    width: 50,
    customRender: (text, record, index) => {
      return index + 1;
    },
  },
  {
    title: "异常批次编号",
    dataIndex: "pkgCode",
    key: "pkgCode",
  },
  {
    title: "商品名称",
    dataIndex: "productName",
    key: "productName",
  },
  {
    title: "采购单",
    dataIndex: "purchaseNo",
    key: "purchaseNo",
  },
  {
    title: "入库单",
    dataIndex: "inboundCode",
    key: "inboundCode",
  },
  // {
  //   title: "异常编码",
  //   dataIndex: "exceptionRelation",
  //   key: "exceptionRelation",
  // },
  // {
  //   title: "商品名称",
  //   dataIndex: "productName",
  //   key: "productName",
  // },
  {
    title: "次品件数",
    dataIndex: "amount",
    key: "amount",
  },
  {
    title: "次品类型",
    dataIndex: "exceptionNames",
    key: "exceptionNames",
    customRender: (text, record) => {
      let str = ''
      record.exceptionNames.forEach(item =>{
        str += (item + "；")
      })
      return str.slice(0,-1)
    },
  },
  {
    title: "次品图片",
    dataIndex: "imgs",
    key: "imgs",
    scopedSlots: {
      customRender: "errorImg",
    },
  },
  {
    title: "库区",
    dataIndex: "regionName",
    key: "regionName",
  },
  {
    title: "货格码",
    dataIndex: "gridCode",
    key: "gridCode",
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    key: "createTime",
  },
  {
    title: "人员处理",
    dataIndex: "createrName",
    key: "createrName",
  },
  {
    title: "处理结果",
    dataIndex: "tag",
    key: "tag",
    customRender: (text, record) => {
      return taglist.map(item =>{
        if(item.value == text){
          return item.label
        }
      })
    },
  },
  {
    title: "业务处理状态",
    dataIndex: "serviceStatus",
    key: "serviceStatus",
    customRender: (text,record) => {
        return servicelist[text]
    },
  },
  {
    title: "仓库处理状态",
    dataIndex: "wareStatus",
    key: "wareStatus",
    customRender: (text,record) => {
        return warehouselist[text]
    },
  },
  {
    title: "订单来源",
    dataIndex: "systemSource",
    key: "systemSource",
    customRender: (text,record) => {
        return {1:'D2C',2:'B2B'}[text]||'-'
    },
  },
  {
    title: "操作",
    dataIndex: "idAction",
    key: "idAction",
    width:170,
    fixed: "right",
    scopedSlots: {
      customRender: "action",
    },
  },
];

export const dataSource = [
  {
    warehouse: "1",
    regionName: "1",
    regionContact: "1",
    contactPhone: "1",
    address: "1",
    total: "1",
    result: "1",
    num: "1",
    type: "1"
  },
];
